import React from "react";
import Lightbox from "react-awesome-lightbox";
// You need to import the CSS only once
import "react-awesome-lightbox/build/style.css";
import PanoramaIcon from "@material-ui/icons/Panorama";

function ImageView({ open,onClick, ...props }) {
  return open ? <Lightbox onClose={()=>onClick(false)} {...props} /> :  <PanoramaIcon onClick={()=>onClick(true)} color="primary" size="small" />;
}

export default ImageView;
